<script setup>
import { ref, onMounted } from "vue";

const infoList = [
  "1回90分を基本に、単発から継続的なレッスンまで、柔軟に対応。",
  "会場:東京都、神奈川県内の指定のスタジオ、あるいは生徒様ご指定の会場にて。(※出張費用を頂く場合があります)。オンラインでの実施も承っております。",
];

const shrinkTitle = ref(null);
const shrinkElement = ref(null);
onMounted(() => {
  window.addEventListener("scroll", shrinkTitleOnScroll);
  window.addEventListener("scroll", shrinkElementOnScroll);
});

const shrinkTitleOnScroll = () => {
  const element = shrinkTitle.value;
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    if (elementPosition - window.innerHeight <= -120) {
      element.classList.add("-show");
      window.removeEventListener("scroll", shrinkTitleOnScroll);
    }
  }
};
const shrinkElementOnScroll = () => {
  const element = shrinkElement.value;
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    if (elementPosition - window.innerHeight <= -120) {
      element.classList.add("-show");
      window.removeEventListener("scroll", shrinkElementOnScroll);
    }
  }
};
</script>

<template>
  <div class="lesson" id="lesson">
    <div class="background-content">
      <p class="background-right shrink-title -right" ref="shrinkTitle">LESSON</p>
    </div>
    <div class="lesson-content shrink-element" ref="shrinkElement">
      <p class="section-title">個人レッスン</p>
      <div class="lead">
        <p>個人・グループでのクラリネット、ジャズ理論(アドリブ)のレッスンを行っております。</p>
      </div>

      <ul class="info-list">
        <li v-for="info in infoList" :key="info">{{ info }}</li>
      </ul>

      <p class="price-note">料金のお問い合わせ、レッスンご希望の方はフォームよりご連絡ください。</p>

      <div class="cta-wrap">
        <a class="cta" href="#contact" v-scroll-to="'#contact'">レッスンのお問い合わせはこちら</a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" src="./style.scss" scoped></style>
